(function () {
  'use strict';

  angular
    .module('vcdms.vcdocument')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmsdocument', {
        url: '/vcdmsdocument',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;documentsearch document="" documentref="" editinplace="true"&gt;</tt></h3><div ui-view="documentsearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;documentsearch document="" documentref="" parentsave=""&gt;</tt></h3><div ui-view="documentsearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;documenteditor document="" mode="" onClose=""&gt;</tt></h3><div ui-view="documenteditview"></div>
              <h3 class="alert alert-info"><tt>&lt;documentnew&gt;</tt></h3><div ui-view="documentnewview"></div>
              <h3 class="alert alert-info"><tt>&lt;documentlist documents="?"&gt;</tt></h3><div ui-view="documentlistview"></div>
              <h3 class="alert alert-info"><tt>&lt;documentlist key="?" value="?"&gt;</tt></h3><div ui-view="documentlistview2"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcdocument entered');
        }
      });


    $stateProvider
      .state('playground.vcdmsdocument.allcomponents', {
        url: '/allcomponents',
        resolve: {
          document: function () {
            return '';
          },
          documentref: function () {
            return '';
          },
          somedocument: function (Document) {
            return Document.$find('572b31b07c01597e3e150923');
          },
          alldocuments: function (Document) {
            return Document.$search({active: {$ne: false}});
          },
          consultdocuments: function (Document) {
            return Document.$searchMetaBy('consultid', '57163e2f7c01595d1efa74cf');
          },
          parentsavesearch: function () {
            return function (document, documentref) {
              console.log('debug: dummy parentsave called for documentsearch with: ', document, documentref);
            };
          },
          eip: function () {
            return true;
          },
          keyconsultid: function () {
            return 'consultid';
          },
          valconsultid: function () {
            return '57163e2f7c01595d1efa74cf';
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'documentsearchview@playground.vcdmsdocument': {
            component: 'documentsearch',
            bindings: {
              document: 'document',
              documentref: 'documentref',
              editinplace: 'eip'
            }
          },
          'documentsearchview2@playground.vcdmsdocument': {
            component: 'documentsearch',
            bindings: {
              document: 'document',
              documentref: 'documentref',
              parentsave: 'parentsavesearch'
            }
          },
          'documenteditview@playground.vcdmsdocument': {
            component: 'documenteditor',
            bindings: {
              document: 'somedocument'
            }
          },
          'documentnewview@playground.vcdmsdocument': {
            component: 'documentnew',
            bindings: {}
          },
          'documentlistview@playground.vcdmsdocument': {
            component: 'documentlist',
            bindings: {
              documents: 'alldocuments'
            }
          },
          'documentlistview2@playground.vcdmsdocument': {
            component: 'documentlist',
            bindings: {
              key: 'keyconsultid',
              value: 'valconsultid'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcdmsdocument.allcomponents entered');
        }
      });


  }// all routes


}());
